const $ = require('jquery');
require('slick-carousel/slick/slick');

/*
 * Slider
 */

$(document).ready(function(){

    window.$$$=$;

    let $carouselDefaults = {
        prevArrow: '<button type="button" class="slick-prev slick-arrow slick-arrow--prev"><i class="fa fa-fw fa-chevron-left" aria-hidden="true"></i></button>',
        nextArrow: '<button type="button" class="slick-next slick-arrow slick-arrow--next"><i class="fa fa-fw fa-chevron-right" aria-hidden="true"></i></button>',
        dots: true,
        infinite: true,
        arrows: true,
        speed: 600,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    let $homeSlider = $('.home-slider');

    if ($homeSlider.length === 0) {
        return;
    }

    $homeSlider.slick($.extend({}, $carouselDefaults, {
        arrows: false,
        infinite: true,
        lazyLoad: 'ondemand',
        speed: 800, // same timing as dots transition
        // autoplay: true,
        autoplay: true,
        autoplaySpeed: 8000,
        cssEase: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)', //custom ease for Hertz
        rows: 0, // fix broken things
        waitForAnimate: false,
    }));

    //__________ Fix slider positioning shortly after resize __________
    let _timeout = null;
    window.addEventListener('resize', event => {
        if (_timeout !== null) {
            window.clearTimeout(_timeout);
            _timeout = null;
        }

        _timeout = window.setTimeout(() => {
            $homeSlider.slick('setPosition');

            _timeout = null;
        }, 1000); //waits a full second before fixing, because sometimes the delayed event messes up when resizing erratically
    });

});